import React, { forwardRef } from "react"
import styled, { css } from "styled-components"
import { useStore } from "../zustandStore"

const CirclePlayIconSVG = forwardRef((props, ref) => {
  const visible = props.visible == null ? true : props.visible
  const disableBlinking = useStore((state) => state.publicAppSettings.blinkingAnimations === false)
  return (
    <SVGWrapper disableBlinking={disableBlinking} ref={ref} visible={visible} className={`${disableBlinking ? '' : 'blinking blink-0 '}` + props.className + (props.visible ? ' visible' : '')}>
      <svg xmlns="http://www.w3.org/2000/svg" color={props.color} width={props.width || '0.6em'} viewBox="0 0 60 60" preserveAspectRatio="xMidYMid meet">
        <path d="M30,0C13.458,0,0,13.458,0,30s13.458,30,30,30s30-13.458,30-30S46.542,0,30,0z M45.563,30.826l-22,15 C23.394,45.941,23.197,46,23,46c-0.16,0-0.321-0.038-0.467-0.116C22.205,45.711,22,45.371,22,45V15c0-0.371,0.205-0.711,0.533-0.884 c0.328-0.174,0.724-0.15,1.031,0.058l22,15C45.836,29.36,46,29.669,46,30S45.836,30.64,45.563,30.826z"/>
      </svg>
    </SVGWrapper>
  )
})

export default CirclePlayIconSVG

const SVGWrapper = styled.div`
  svg {
    --color: ${props => props.color || '#e23333'};
    enable-background:new 0 0 122.88 122.88;
    path{fill:var(--color);}

    transition-property: opacity;
    transition-duration: 350ms;

    ${props => props.visible ? css`
      opacity: 1;
    ` : css`
      opacity: 0;
    `}
    scale: 90%; // idk this just fixes weird cutoffs that happen sometimes

  }

  transition-property: opacity;
  ${props => props.disableBlinking
    ? css`
      opacity: 0.9;
      transition-duration: 500ms;
    ` : css`
      opacity: 0.6;
      transition-duration: 1750ms;
      &.blink-on { opacity: 0.85; }
      &.blink-off { opacity: 0.35; }
    `
  }

  align-self: center;
  line-height: 0;
`
